import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id C47F7F19-362E-49BA-8BC4-2FE6161AD44D
 * name file-replace-outline
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-replace-outline.svg
 * tags
 * - Files / Folders 
 */
export const FileReplaceOutlineIcon = createSvgIcon(<><path d="M14,3L12,1H4A2,2 0 0,0 2,3V15A2,2 0 0,0 4,17H11V19L15,16L11,13V15H4V3H14M21,10V21A2,2 0 0,1 19,23H8A2,2 0 0,1 6,21V19H8V21H19V12H14V7H8V13H6V7A2,2 0 0,1 8,5H16L21,10Z" /></>, 'FileReplaceOutlineIcon');
export default FileReplaceOutlineIcon